import validates from '@/libs/validates.js';
import { CheckIdCardClass } from '@/libs/credential-validate';
import moment from 'moment';
import insuranceApi from '@/api/insurance-api';


// 证件号码校验函数
const checkCardCode = (rule, value, callback) => {
  if (validates.inputRegexpCollection.idCardReg.test(value) && CheckIdCardClass.checkIdCard(value)) {
    callback();
  } else {
    callback(new Error('请输入正确的证件号码'));
  }
};

// 表单验证则表达式
export const rules = { 
  start_date: [validates.insuranceRegCollection.date('起保日期')],
  protect_days: [validates.insuranceRegCollection.required('保障天数')],
  destination: [validates.insuranceRegCollection.required('旅行目的地')],
  email: [
    validates.insuranceRegCollection.required('电子邮箱'),
    validates.insuranceRegCollection.email('电子邮箱'),
  ],
  'applicant.cname': [
    validates.insuranceRegCollection.required('中文企业名称'),
    validates.insuranceRegCollection.companyName('中文企业名称'),
  ],
  'applicant.ename': [
    validates.insuranceRegCollection.required('企业名称拼音'),
    validates.insuranceRegCollection.companyEname('企业名称拼音'),
  ],
  'applicant.card_code': [
    validates.insuranceRegCollection.required('社会信用代码'),
    validates.insuranceRegCollection.creditCode('社会信用代码'),
  ],
  'applicant.mobile': [
    validates.insuranceRegCollection.required('手机号码'),
    validates.insuranceRegCollection.mobile('手机号码'),
  ],

  'insurants.cname': [
    validates.insuranceRegCollection.required('姓名'),
    validates.insuranceRegCollection.insurantsName('姓名'),
  ],
  'insurants.ename': [
    validates.insuranceRegCollection.required('姓名拼音'),
    validates.insuranceRegCollection.ename('姓名拼音'),
  ],
  'insurants.card_type': [validates.insuranceRegCollection.radio('证件类型')],
  'insurants.idCard': [
    validates.insuranceRegCollection.required('证件号码'),
    { validator: checkCardCode, trigger: 'blur' },
  ], // 身份证号码使用单独的校验函数
  'insurants.passport': [
    validates.insuranceRegCollection.required('证件号码'),
    validates.insuranceRegCollection.passport('证件号码'),
  ], // 护照校验
  'insurants.birthday': [validates.insuranceRegCollection.date('出生日期')],
  'insurants.sex': [validates.insuranceRegCollection.radio('性别')],
  'insurants.email': [
    validates.insuranceRegCollection.required('电子邮箱'),
    validates.insuranceRegCollection.email('电子邮箱'),
  ],
  'insurants.mobile': [
    validates.insuranceRegCollection.required('手机号码'),
    validates.insuranceRegCollection.mobile('手机号码'),
  ],
  'insurants.job': [
    { required: true, type: 'array', message: '请选择职业', trigger: 'blur' },
  ],
  'insurants.for_who': [
    { required: true, message: '请选择与投保人关系', trigger: 'blur' },
  ],
  'insurants.relation_id': [
    { required: true, type: 'number', message: '请选择与投保人关系', trigger: 'blur' },
  ],
};

export default {
  // 从身份证抽取信息，并自动填入
  extractInfoFromIdcard(item) {
    const { card_type, card_code } = item;
    if (!card_type || card_type === 1) {
      if (validates.inputRegexpCollection.idCardReg.test(card_code) && CheckIdCardClass.checkIdCard(card_code)) {
        if (card_code.length === 15) {
          item.birthday = new Date(moment(`19${card_code.substring(6, 12)}`).format('YYYY-MM-DD'));
          item.sex = card_code.substring(13, 14) % 2;
        } else {
          item.birthday = new Date(moment(card_code.substring(6, 14)).format('YYYY-MM-DD'));
          item.sex = card_code.substring(16, 17) % 2;
        }
      }
    }
  },
  // 根据选项计算保险金额
  calculatePrice(insuranceData) {
    return new Promise((resolve, reject) => {
      const { case_code, travel_delays, protect_days, insurant_age } = insuranceData;
      const params = { case_code, travel_delays, protect_days, insurant_age };
      if (protect_days === '1年') {
        params.protect_days = '365天';
      } else if (protect_days.indexOf('1年') > -1 && protect_days.length > 2) {
        params.protect_days = '365天';
        params.extended = protect_days;
      } else {
        params.protect_days = protect_days;
      }
      insuranceApi.insuranceSimpleTrial(params).then((data) => {
        resolve({
          single_price: data.single_price,
          original_price: data.original_price,
        });
      }).catch((e) => {
        if (e) console.log(e);
        reject();
      });
    });
  },
};




// WEBPACK FOOTER //
// ./src/pages/insurance/services/insurance-info-service.js